import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";


import en from "./en/common.json";
import pt from "./pt/common.json";

const resources = {
  en: { common: en },
  pt: { common: pt }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    // vai detectar por localStorage -> navigator -> htmlTag
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"]
    },
    ns: ["common"],
    defaultNS: "common",
    interpolation: { escapeValue: false }
  });

// manter o atributo lang do <html> consistente:
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng.startsWith("pt") ? "pt" : "en";
});

export default i18n;
